import { notify } from 'utils/reduxUtils';

export const types = {
  INIT: 'processes/supplierTables/listPage/INIT',
  CREATE_CUSTOM_TABLE_ERROR:
    'processes/supplierTables/listPage/CREATE_CUSTOM_TABLE_ERROR',
  CREATE_CUSTOM_TABLE_REQUEST:
    'processes/supplierTables/listPage/CREATE_CUSTOM_TABLE_REQUEST',
  CREATE_CUSTOM_TABLE_SUCCESS:
    'processes/supplierTables/listPage/CREATE_CUSTOM_TABLE_SUCCESS',
  CREATE_MODAL_OPEN: 'processes/supplierTables/listPage/CREATE_MODAL_OPEN',
  CREATE_MODAL_CLOSE: 'processes/supplierTables/listPage/CREATE_MODAL_CLOSE',
};

export const init = ({ customTables }) => ({
  type: types.INIT,
  payload: { customTables },
});

export const create = {
  request: ({ name }) => ({
    type: types.CREATE_CUSTOM_TABLE_REQUEST,
    payload: { name },
  }),
  success: ({ customTable }) => ({
    type: types.CREATE_CUSTOM_TABLE_SUCCESS,
    payload: { customTable },
  }),
  error: notify(
    (error) => ({
      type: types.CREATE_CUSTOM_TABLE_ERROR,
      payload: error,
    }),
    'Failed to create custom table',
  ),
};

export const createModal = {
  open: () => ({
    type: types.CREATE_MODAL_OPEN,
  }),
  close: () => ({
    type: types.CREATE_MODAL_CLOSE,
  }),
};
